import {defineMessages} from 'react-intl'

import {OfferAlertVariant} from './constants'

export const offerAlertMessages = defineMessages({
  priceIncreaseMessageV2: {
    id: 'priceIncreaseMessageV2',
    defaultMessage: 'Price just increased by {price}.'
  },
  priceDropMessageV2: {
    id: 'priceDropMessageV2',
    defaultMessage: 'Price just dropped by {price}.'
  },
  why: {
    id: 'why',
    defaultMessage: 'Why?'
  },
  priceChange: {
    id: 'priceChange',
    defaultMessage: 'Price change'
  },
  priceChangeOverlayContent: {
    id: 'priceChangeOverlayContent',
    defaultMessage:
      'Prices change based on demand. The latest prices can take a few minutes to reach us and can change after making a selection.'
  }
})

export const overlayTranslations = {
  price: {
    centerContent: {
      id: offerAlertMessages.priceChange.id,
      defaultMessage: offerAlertMessages.priceChange.defaultMessage
    },
    content: {
      id: offerAlertMessages.priceChangeOverlayContent.id,
      defaultMessage:
        offerAlertMessages.priceChangeOverlayContent.defaultMessage
    }
  }
}

export const variantTranslations = {
  [OfferAlertVariant.PriceDropV2]: {
    id: offerAlertMessages.priceDropMessageV2.id,
    defaultMessage: offerAlertMessages.priceDropMessageV2.defaultMessage
  },
  [OfferAlertVariant.PriceIncreaseV2]: {
    id: offerAlertMessages.priceIncreaseMessageV2.id,
    defaultMessage: offerAlertMessages.priceIncreaseMessageV2.defaultMessage
  }
}
